<template>
  <div 
    class='container-feedback-dialog'
    :class="[openingHidden ? 'hidden anim-open' : opening ? 'anim-open' : closed ? 'anim-closed' : !hidden ? 'anim-hidden' : 'anim-main']"
    >
    <div class='container-feedback-sc'>
      <div class='icon-feedback mr-2 mt-2 ml-1' @click="onClickIcon">
        <base-logo
          :filename="logoFeedback"
          alt="EdasNEO"
        />
      </div>
      <div class="flex flex-col text-sm w-full">
        <div class="flex flex-row mb-2 justify-between w-full">
          <FeedbackContentTagAgency v-if="TipoPropuesta === 'TagOrganismo'" :valores="valores"/>
          <div v-else></div>
          <base-button-icon
            @click="collapseFeedback"
            ariaLabel="Ocultar propuesta"
            name="chevronright"
            mode="secondary-phantom-blue"
            size="sm"
            iconSize="sm"
            class="mr-6 ml-2 hover:bg-primary-200 dark:bg-darkblue-800 dark:text-darkblue-200 rounded-full w-5 h-5"
            aria-label="Ocultar"
          />
        </div>
        <div class="flex flex-row justify-center">
          <base-button-icon
            @click="acceptFeedback"
            ariaLabel="Aceptar propuesta"
            name="check"
            mode="secondary-phantom-blue"
            size="sm"
            iconSize="sm"
            class="hover:bg-primary-200 dark:bg-darkblue-800 dark:text-darkblue-200 rounded-full w-5"
          />
          <base-button-icon
            @click="declineFeedback"
            ariaLabel="Cancelar propuesta"
            name="cross"
            mode="secondary-phantom-blue"
            size="sm"
            iconSize="sm"
            class="ml-14 mr-14 hover:bg-primary-200 dark:bg-darkblue-800 dark:text-darkblue-200 rounded-full w-5"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FeedbackContentTagAgency from '@/components/feedbackcontent/FeedbackContentTagAgency.vue'
import { getPropuesta } from '@/services/proposals/getPropuesta'
import { updatePropuesta } from '@/services/proposals/updatePropuesta'

export default {
  name: 'feedback-dialog',
  components: {
    FeedbackContentTagAgency
  },
  props: {
  },
  mounted () {
    if (this.user.Rol === 'Administrador') {
      this.checkGenerateDialog()
    }
  },
  data () {
    return {
      openingHidden: true,
      opening: false,
      hidden: false,
      closed: false,
      generated: false,
      // Datos Propuesta
      idQuestion: -1,
      valores: [],
      TipoPropuesta: '',
    }
  },
  watch: {
    isUserData: function () {
      if (this.user.Rol === 'Administrador') {
        this.checkGenerateDialog()
      }
    },
    // actualRoute: function () {
    //   if (this.actualRoute.includes('configurations/tags')) {
    //     console.log('VOLVER A CARGAR')
    //   }
    // }
  },
  computed: {
    actualRoute () {
      return this.$store.getters['app/actualRoute']
    },
    user: function () {
      return this.$store.getters['auth/user']
    },
    isUserData: function () {
      return this.user !== undefined && this.user !== null
    },
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
    logoFeedback: function () {
      if (this.darkMode) {
        return 'edasneo-icon-white.png'
      }
      return 'edasneo-icon.png'
    },
  },
  methods: {
    checkGenerateDialog () {
      if (this.generated === false && this.isUserData) {
        this.generated = true
        this.openDialog()
      }
    },
    getData: async function () {
      try {
        // this.$store.commit('setIsLoading', true)
        const response = await getPropuesta()
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          if (response.Respuesta !== null) {
            this.idQuestion = response.Respuesta.IdPropuesta
            this.valores = response.Respuesta.valores
            this.TipoPropuesta = response.Respuesta.TipoPropuesta
          }
        }
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        // this.$store.commit('setIsLoading', false)
      }
    },
    sendAnswer: async function (value) {
      try {
        // this.$store.commit('setIsLoading', true)
        const params = {
          idPropuesta: this.idQuestion,
          answer: value,
        }
        const response = await updatePropuesta(params)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          if (value) {
            this.doFeedback('Datos guardados correctamente', 'success')
          }
        }
      } catch (error) {
        console.error(error)
        // this.doFeedback()
      } finally {
        // this.$store.commit('setIsLoading', false)
      }
    },
    openDialog: async function () {
      const self = this
      setTimeout(async () => {
        // Proceso de obtención de datos
        await this.getData()
        // En caso de tener feedback: 
        if (this.idQuestion !== -1 || this.idQuestion !== -'1') {
          self.opening = true
          self.openingHidden = false
        }
      }, 1500)
    },
    onClickIcon () {
      this.opening = false
      this.hidden = !this.hidden
    },
    acceptFeedback () {
      console.log('Accept')
      // Proceso de aceptación
      this.sendAnswer(true)
      this.closed = true
    },
    declineFeedback () {
      console.log('Decline')
      // Proceso de rechazo
      this.sendAnswer(false)
      this.closed = true
    },
    collapseFeedback () {
      console.log('Collapse')
      this.hidden = false
    }
  }
}
</script>

<style scoped>
.container-feedback-dialog{
    position: fixed;
    right: -320px;
    bottom: 100px;
    z-index: 1999;
}
.container-feedback-sc{
    display: flex;
    /* gap: 14px; */
    -webkit-box-align: center;
    align-items: center;
    height: 80px;
    /* height: 70px; */
    width: 380px;
    /* width: 266px; */
    background-color: var(--Component-background-);
    color: var(--Component-text-color-);
    box-shadow: rgb(0 0 0 / 16%) 0px 4px 8px;
    border-radius: 999999px 0px 0px 999999px;
    border-width: 2px 0px 2px 2px;
    border-top-style: solid;
    border-bottom-style: solid;
    border-left-style: solid;
    border-image: initial;
    border-top-color: var(--primary-DEFAULT);
    border-bottom-color: var(--primary-DEFAULT);
    border-left-color: var(--primary-DEFAULT);
    border-right-style: initial;
    border-right-color: initial;
    padding: 0px 0px 0px 10px;
    box-sizing: content-box;
    animation-name: container-sc-anim;
    animation-duration: 0.5s;

}
.anim-main{
    animation-duration: 0.5s;
    animation-fill-mode: forwards;
    animation-name: container-anim;
}
.anim-hidden{
    animation-duration: 0.5s;
    animation-fill-mode: forwards;
    animation-name: container-anim-hide;
}
.anim-closed{
    animation-duration: 0.5s;
    animation-fill-mode: forwards;
    animation-name: container-anim-close;
}
.anim-open{
    animation-duration: 1.5s;
    animation-fill-mode: forwards;
    animation-name: container-anim-open;
}
.icon-feedback{
  cursor: pointer;
  width: 65px;
  height: 65px;
}
@keyframes container-anim {
  0%   {right: -316px;}
  80%  {right: 0px;}
  100% {right: -20px;}
  /* 50%  {right: 0px;}
  70%  {right: -10px;}
  100% {right: 0px;} */
}
@keyframes container-anim-hide {
  0%   {right: -20px;}
  80%  {right: -339px;}
  100% {right: -316px;}
}
@keyframes container-anim-close {
  0%   {right: -20px;}
  100%  {right: -480px;}
}
@keyframes container-anim-open {
  0%   {right: -1800px;}
  100%  {right: -316px;}
}
@keyframes container-sc-anim {
  0%   {width: 380px;}
  50%  {width: 464px;}
  100% {width: 380px;}
}

</style>
